import type { ReactNode } from 'react';

export const symbol_ifl: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M690-270q17-17 17-42t-17-42q-17-17-42-17t-42 17q-17 17-17 42t17 42q17 17 42 17t42-17ZM520-440q17-17 17-42t-17-42q-17-17-42-17t-42 17q-17 17-17 42t17 42q17 17 42 17t42-17ZM354-606q17-17 17-42t-17-42q-17-17-42-17t-42 17q-17 17-17 42t17 42q17 17 42 17t42-17ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
